import React from 'react';
const stats = [{
  value: '500+',
  label: 'Happy Clients'
}, {
  value: '£10M+',
  label: 'Revenue Generated'
}, {
  value: '150%',
  label: 'Avg. Traffic Increase'
}, {
  value: '10+',
  label: 'Years Experience'
}];
export function Stats() {
  return <section className="py-16 bg-emerald-600" data-id="element-169">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x divide-emerald-500/30" data-id="element-171">
          {stats.map((stat, index) => <div key={index} className="p-4" data-id="element-172">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2 tracking-tight" data-id="element-173">
                {stat.value}
              </div>
              <div className="text-emerald-100 font-medium text-lg" data-id="element-174">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}